export default "__VITE_ASSET__BAojYHJj__"